import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { Divider, Select } from 'antd';
import InserirFiscalizacao from './InserirFiscalizacao';
import SelosGarantia from './mySelosGarantia';
import $ from 'jquery';
import { Dialog } from '@progress/kendo-react-dialogs';
import { Button } from "@progress/kendo-react-buttons";
import { Input } from "@progress/kendo-react-inputs";
import { toast } from "react-toastify";
import DropDownCellIntervaloSelosGarantia from "./myDropDownCellIntervaloSelosGarantia";
const { Option } = Select
var isModalOpen = false;
var optionsEntidade = [];
var optionsEntidadeData = [];
var entidadeSelected = null;
var DropDownCellTipoVasilha = null;
var thisMySelect = null;
var dataItemOutro;
var seloFinal;
var seloInicial;
var Dropdownintervalos = [];
var fieldselected;
var objectGarantia = [];
var objectGarantiaAE = [];
var classNameIVDP;


function myFunction(selection) {
  optionsEntidade = [];
  (async (e) => {

    entidadeSelected = selection != null ? selection : $('#id-select-Entidade [name="form-field-name"]').val();

    const data = {"IDEntidade": entidadeSelected}
    const EtiquetasSeguranca = await services.apiCall.requestApi(
        "/Selos/GetSelosDisponiveisAposicao",
        data,
        "get"
    );

    if(EtiquetasSeguranca){
      EtiquetasSeguranca.map((Etiqueta, index) => (
        Dropdownintervalos.push(Etiqueta),
        optionsEntidade.push(<Option key={index} value={Etiqueta.idOperacaoSelos}>{Etiqueta.serie + " " + Etiqueta.intervalo}</Option>)
      ));
    }
    
  })();
};

class SelectCellSelosGarantia extends React.Component {

  state = {
    showDialog: false,
    objectGarantia2: [],
    objectGarantiaAE2: []
  };
  static changeValueFromSelect = (e) => {

    myFunction(e);
    
  }

  handleErase = (seloInicial , seloFinal) => {
    // Remove the selected item from the state variable
    if(this.props.field == 'SelosGarantiaAE'){
      if(objectGarantiaAE.length == 0){
        objectGarantiaAE = this.props.dataItem.SelosGarantiaAE
      }
      objectGarantiaAE = objectGarantiaAE.filter((item) => item.seloInicial !== seloInicial && item.seloFinal !== seloFinal);
      
      this.props.dataItem.SelosGarantiaAE = objectGarantia;
      
      this.setState((prevState) => ({
        objectGarantiaAE2: prevState.objectGarantiaAE2.filter(
          (item) => item.seloInicial !== seloInicial && item.seloFinal !== seloFinal
        ),
      }));
    }else{
      if(objectGarantia.length == 0){
        objectGarantia = this.props.dataItem.SelosGarantiaIVDP
      }
      objectGarantia = objectGarantia.filter((item) => item.seloInicial !== seloInicial && item.seloFinal !== seloFinal);

      this.props.dataItem.SelosGarantiaIVDP = objectGarantia;

      this.setState((prevState) => ({
        objectGarantia2: prevState.objectGarantia2.filter(
          (item) => item.seloInicial !== seloInicial && item.seloFinal !== seloFinal
        ),
      }));
    }
    
  };
  handleChangeCertProcSelosSeg = (e) => {

    var dataItemArray = [];
    var dataItemArrayField = [];

    for(let i = 0; i < e.length; i++){
      dataItemArray.push(optionsEntidade.find(c=> c.props.value == e[i]).props)
    }

    optionsEntidadeData[this.props.field] = (dataItemArray.length > 0 ? dataItemArray : []);

    this.props.onChange({
      dataItem: dataItemOutro.dataItem,
      field: this.props.field,
      syntheticEvent: e != null ? e.syntheticEvent : null,
      value: e.length > 0 ? e : null
    });

  }

  handleOpenDialog = (e) => {
    $("#k-loading-mask Display_loadiing").css("display" , "block");
    $("#k-loading-mask Display_loadiing").css("z-index" , "2147483647");
    fieldselected = this.props.field;
    
    if(fieldselected == "SelosGarantiaIVDP" && $(".k-master-row.k-grid-edit-row .selosgarantiaIVDP").length >= parseInt($(".NGarrafasIVDP").val())){
        toast.error("O número de selos não pode exceder o número de garrafas");
        return;
      
    }else if(fieldselected == "SelosGarantiaAE" && $(".k-master-row.k-grid-edit-row .selosgarantiaAE").length >= parseInt($(".NGarrafasAE").val())){
        toast.error("O número de selos não pode exceder o número de garrafas");
        return;
    }else{
        this.setState({ showDialog: true });
    }
  };

  static editeGrid(){
   
    objectGarantia = [];
    objectGarantiaAE = [];
  }

  handleCloseDialog = () => {
    this.setState({ showDialog: false });
  };
  
  incrementValue = (id) => {
    if($('#' + id).val() != null & $('#' + id).val() != ""){
        var value = parseInt($('#' + id).val(), 10);
        value = new Array(8 - (value + '').length).join('0') + (value);
        return value;
    }
}
  handleSave = (e) => {
    var resultIntervalo = DropDownCellIntervaloSelosGarantia.returnValue();
    seloInicial = $('#seloInicial').val();
        if($('#seloInicial').val() == null || resultIntervalo == null){

            toast.error("Preencha todos os campos");
            return;
        }


       if(resultIntervalo.text.substr(6,7) > $('#seloInicial').val() || resultIntervalo.text.substr(14) < $('#seloInicial').val()) {
          toast.error("o selo tem de estar dentro do intervalo selecionado");
          return;
       }
        // if(parseInt($('#seloInicial').val()) > parseInt($('#seloFinal').val())){
        //     toast.error("Selo inicial tem que ser menor que o selo final");
        //     return;
        // }
        
        // if($('#seloInicial.k-state-invalid').length == 0 && $('#seloFinal.k-state-invalid').length == 0){
        //     seloInicial = this.incrementValue('seloInicial');
        //     seloFinal = this.incrementValue('seloFinal');
        // }else{
        //     toast.error("Erro no intervalo dos selos");
        //     return;
        // }

        if(fieldselected == 'SelosGarantiaAE'){
          var inicial = parseInt($(".SelosGarantiaAE #seloInicial").val());
          var final = parseInt($(".SelosGarantiaAE #seloFinal").val());
          
          // var quantos = (final - inicial) + 1;
  
          // if(quantos > parseInt($(".NGarrafasAE").val())){
          //   toast.error("O número de selos não pode exceder o número de garrafas");
          //   return;
          // }
        }

        if(fieldselected == 'SelosGarantiaIVDP'){
          var inicial = parseInt($(".SelosGarantiaIVDP #seloInicial").val());
          var final = parseInt($(".SelosGarantiaIVDP #seloFinal").val());
          
          // var quantos = (final - inicial) + 1;
  
          // if(quantos > parseInt($(".NGarrafasIVDP").val())){
          //   toast.error("O número de selos não pode exceder o número de garrafas");
          //   return;
          // }
        }

        
        

        if(fieldselected == 'SelosGarantiaAE'){
          objectGarantiaAE.push({"idIntervalo" : resultIntervalo,'seloInicial':seloInicial,'seloFinal':seloFinal , field: fieldselected});
        }else{
          objectGarantia.push({"idIntervalo" : resultIntervalo,'seloInicial':seloInicial,'seloFinal':seloFinal , field: fieldselected});
        }
        
       
        

        this.props.onChange({
          dataItem: this.props.dataItem,
          field: this.props.field,
          syntheticEvent: e != null ? e.syntheticEvent : null,
          value: e.length > 0 ? e : null
        });

        this.setState({ showDialog: false });
    
  };

  render() {
    const { showDialog} = this.state;
    thisMySelect = this;
   
    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';

    if(field == "SelosGarantiaAE" ){
      classNameIVDP = "SelosGarantiaAE";
      if(this.props.dataItem.SelosGarantiaAE === undefined){
        objectGarantiaAE = [];
      }
      if(objectGarantiaAE.length > 0 && dataItem.inEdit == true ){
        var dataValue = dataItem[field] = objectGarantiaAE;
      }
      // else if(dataItem[field] && this.props.dataItem.inEdit == true && dataItem.NewItem == false){
      //   var dataValue = dataItem[field] === null ? '' : dataItem[field];
      // }
      else if(dataItem[field] && this.props.dataItem.inEdit == true && dataItem.NewItem == true){
        var dataValue = ''
      }
      else if(dataItem.NewItem == false){
        var dataValue = dataItem[field] === null ? '' : dataItem[field];}
      else{
        var dataValue = dataItem[field] === null ? '' : dataItem[field];
      }
    }else{
      classNameIVDP = "SelosGarantiaIVDP";
      if(this.props.dataItem.SelosGarantiaIVDP === undefined){
        objectGarantia = [];
      }
      if(objectGarantia.length > 0 && dataItem.inEdit == true){
        var dataValue = dataItem[field] = objectGarantia;
      }
      // else if(dataItem[field] && this.props.dataItem.inEdit == true && dataItem.NewItem == false){
      //   var dataValue = dataItem[field] === null ? '' : dataItem[field];
      // }
      else if(dataItem[field] && this.props.dataItem.inEdit == true && dataItem.NewItem == true){
        var dataValue = ''
      }
      else if(dataItem.NewItem == false){
        var dataValue = dataItem[field] === null ? '' : dataItem[field];
      }
      else{
        var dataValue = dataItem[field] === null ? '' : dataItem[field];
      }
    }
    
    
   console.log(dataValue)
        
    if(this.props.dataItem.inEdit == true){
      dataItemOutro = this.props
    }
    var StringArray = "";
    if(dataValue == undefined && field == 'SelosGarantiaAE'){
      objectGarantiaAE = [];
    }else if(dataValue == undefined && field == 'SelosGarantiaobjectGarantiaIVDP'){
      objectGarantia = [];
    }
    return (
      <>
      <td> 
      {dataItem.inEdit ?  <Button onClick={this.handleOpenDialog}>Adicionar</Button> : undefined}

      {showDialog && (
        <Dialog title="Escolha o intervalo" onClose={this.handleCloseDialog}>
          <div class={"input-box active-grey " + classNameIVDP}>
                <div class="col-md-12">
                    <div class="input-box active-grey drop-down-box">
                                    <label class="input-label">Intervalo</label>
                                    <DropDownCellIntervaloSelosGarantia/>
                    </div>
                    <div class="input-box active-grey drop-down-box">
                        <label class="input-label" >Selo</label>
                        <Input type="number" class="input-1 seloInicial blockSpecialChar" name="seloInicial" id="seloInicial" />
                    </div>
                    {/* <div class="input-box active-grey drop-down-box">
                        <label class="input-label" >Selo final</label>
                        <Input type="number" class="input-1 seloFinal blockSpecialChar" name="seloFinal" id="seloFinal" />
                    </div> */}
                </div>
          </div>
            <Button primary onClick={this.handleSave}>
              Adicionar
            </Button>
            <Button onClick={this.handleCloseDialog}>Cancelar</Button>
        </Dialog>
      )} 
      
        {field == 'SelosGarantiaAE' ?  dataItem.inEdit && dataValue != undefined  && dataValue != "" ? dataValue != "" && dataValue != undefined && dataValue[0].idIntervalo != null ? dataValue.map((datavalue,index) => (
              <div className='selosgarantiaAE' style={{display: "flex",flexDirection: "row",alignItems: "center"}}><span key={index} className="ant-select-selection-item-content-etiquetas">{optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value) ? optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value).props.children : datavalue.idIntervalo.text ? datavalue.idIntervalo.text.split(" ")[0] + " " + datavalue.seloInicial : datavalue.idIntervalo.text.split(" ")[0] + " " + datavalue.seloInicial}</span> <button style={{backgroundColor: "transparent", border: "none", padding: "0"}} onClick={() => this.handleErase(datavalue.seloInicial , datavalue.seloFinal)}><i class="fas fa-times"></i></button></div>
              )) : undefined :  dataValue != undefined && dataValue != "" ?  dataValue.map((datavalue,index) => (
                <span key={index} className="ant-select-selection-item-content-etiquetas selosgarantiaAE">{optionsEntidade.length > 0  ? optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value) ? optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value).props.children : datavalue.idIntervalo.text.split(" ")[0] + " "  + datavalue.seloInicial : datavalue.idIntervalo.text.split(" ")[0] + " " + datavalue.seloInicial}</span>
              ) ): undefined  : field == 'SelosGarantiaIVDP' ? dataItem.inEdit && dataValue != undefined  && dataValue != "" ? dataValue != "" && dataValue != undefined && dataValue[0].idIntervalo != null ? dataValue.map((datavalue,index) => (
                <div className='selosgarantiaIVDP' style={{display: "flex",flexDirection: "row",alignItems: "center"}}><span key={index} className="ant-select-selection-item-content-etiquetas">{optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value) ? optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value).props.children : datavalue.idIntervalo.text ? datavalue.idIntervalo.text.split(" ")[0] + " " + datavalue.seloInicial : datavalue.idIntervalo.text.split(" ")[0] + " " + datavalue.seloInicial}</span> <button style={{backgroundColor: "transparent", border: "none", padding: "0"}} onClick={() => this.handleErase(datavalue.seloInicial , datavalue.seloFinal)}><i class="fas fa-times"></i></button></div>
                )) : undefined :  dataValue != undefined && dataValue != "" ?  dataValue.map((datavalue,index) => (
                  <span key={index} className="ant-select-selection-item-content-etiquetas selosgarantiaIVDP">{optionsEntidade.length > 0  ? optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value) ? optionsEntidade.find(c=> c.props.value == datavalue.idIntervalo.value).props.children : datavalue.idIntervalo.text.split(" ")[0] + " "  + datavalue.seloInicial : datavalue.idIntervalo.text.split(" ")[0] + " " + datavalue.seloInicial}</span>
                ) ): undefined : undefined }
       
             
      </td>
      
    </>
    
  )};
    
}
export default SelectCellSelosGarantia;